import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AssessAssistantComponent } from '../components/assess-assistant/assess-assistant.component';
@Component({
  selector: 'evaluations',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    RouterOutlet,
    AssessAssistantComponent
],
  templateUrl: './evaluations.component.html',
  styleUrl: './evaluations.component.css'
})
export class EvaluationsComponent{
}
